exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".div-margin {\n  margin-top: 12px;\n  margin-left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/hybrid-interconnect/hybrid-interconnect-embed.scss
// module id = 7tPB
// module chunks = 0